import vettedLogo from '../assets/vetted-logo.svg';

export const BRAND_NAME = 'Vetted Engineer';
export const BRAND_DOMAIN = 'vettedengineer.com';
export const LOGO_URL = vettedLogo;
export const FAVICON_URL = '/favicon-vetted.svg';
